import { collection, getFirestore, onSnapshot, query, where } from 'firebase/firestore';
import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { applicationInfoData, benefitData, defaultStoreData, employmentData20, formatStore, infoData, summaryData, targetData } from 'src/type';
import { useAppSelector } from 'src/salon/app/hook';

type SchoolPreview = {
  navigation: number;
  documentId: string;
  summary: summaryData;
  info: infoData;
  target: targetData;
  benefit: benefitData;
  employment20: employmentData20;
  applicationInfo: applicationInfoData;
  storeImageLocal: string;
};

const SchoolPreview: React.FC<SchoolPreview> = ({ navigation, summary, info, target, benefit, employment20, applicationInfo, storeImageLocal }) => {

  const company = useAppSelector((state) => state.company.company);
  
  const [ store, setStore ] = useState(defaultStoreData);
  const db = getFirestore();
  
  const [ time ] = useState<number>(new Date().getTime());

  useEffect(() => {
    if (!company?.id) return;

    const q = query( collection(db, 'stores'), where('companyId', '==', company.id), where('number', '==', 1) );

    const unsubscribe = onSnapshot(q, (snapShot) => {
      if (!snapShot.empty) {
        const docSnap = snapShot.docs[0];
        const docData = docSnap.data();
        const newStore = { ...formatStore(docData), id: docSnap.id, };
        setStore(newStore);
      }
    }, (error) => {
      console.error('Firestore取得エラー:', error);
    });

    return () => unsubscribe();
  }, [company?.id]);

  const formatDateToJapanese = (dateStr: string) => {
    if (!dateStr) return '';

    const [ year, month, day ] = dateStr.split('-').map((v) => Number(v));

    if (isNaN(year) || isNaN(month) || isNaN(day)) return '';

    return `${year}年${month}月${day}日`;
  };

  return (
    <>
    <div className={Styles.preview}>
      <div className={Styles.preview_screen}>
        <table className={Styles.preview_screen_table_1}>
          <tbody>
            <tr style={{ height: '18px'}}>
              <td style={{width: '20%'}}></td>
              <td style={{width: '60%', textAlign: 'center', fontSize: '8px'}}><strong>求人票</strong></td>
              <td style={{width: '20%'}}></td>
            </tr>
          </tbody>
        </table>


        <table className={Styles.preview_screen_table_2} style={ navigation === 1 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
          <tbody>
            <tr>
              <td style={{width: '11%', textAlign: 'center', fontSize: '5px', height: "20px"}}>
                魅力
              </td>
              <td style={{width: 'calc(89% - 10px)', textAlign: 'left', fontSize: '8px', padding: '5px'}}>
                {summary.title}
              </td>
            </tr>
            <tr>
              <td style={{width: '11%', textAlign: 'center', fontSize: '5px', height: "30px"}}>
                PR
              </td>
              <td style={{width: 'calc(89% - 10px)', textAlign: 'left', fontSize: '7px', padding: '5px'}} >
                {summary.companyPr}
              </td>
            </tr>
          </tbody>
        </table>

        <div className={Styles.preview_screen_table_3}>
          <table className={Styles.preview_screen_table_3_1} style={ navigation === 2 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
            <tbody>
              <tr>
                <td rowSpan={14} style={{textAlign: 'center', verticalAlign: 'middle', width: '4%', padding: '0%'}}>
                  企　業　情　報
                </td>
                <td style={{ textAlign: 'center', height: '18px', width: '18%', }}>企業名</td>
                <td style={{ paddingLeft: '3px', width: '78%', }}>
                  <span style={{ fontSize: "4px" }}>{info.companyNameKana}</span><br />
                  {info.companyName}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '18px' }}>住所</td>
                <td style={{ paddingLeft: '3px' }}>
                  <span style={{ fontSize: "4px" }}>{info.addressKana}</span><br />
                  {info.address}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '18px' }}>代表者</td>
                <td style={{ paddingLeft: '3px' }}>
                  <span style={{ fontSize: "4px" }}>{info.ownerNameKana}</span><br />
                  {info.ownerName}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px', width: '17%' }}>設立</td>
                <td style={{ paddingLeft: '3px', width: '31%' }}>
                  {info.establishedDate}年
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px', width: '17%' }}>従業員数</td>
                <td style={{ paddingLeft: '3px', width: '31%' }}>
                  {info.numberOfEmployees}人
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px' }}>TEL</td>
                <td style={{ paddingLeft: '3px' }}>
                  {info.phoneNumber}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px' }}>メール</td>
                <td style={{ paddingLeft: '3px' }}>
                  {info.email}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px' }}>HP</td>
                <td style={{ paddingLeft: '3px' }}>
                  {info.homepageUrl}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px' }}>SNS</td>
                <td style={{ paddingLeft: '3px' }}>
                  {info.instagram}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '18px' }}>採用担当</td>
                <td style={{ paddingLeft: '3px' }}>
                  <span style={{ fontSize: "4px" }}>{info.recruiterNameKana}</span><br />
                  {info.recruiterName}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '13px' }}>事業内容</td>
                <td style={{ paddingLeft: '3px' }}>
                  {info.business.contents.length > 1 ? info.business.contents.join('、') : info.business.contents[0]}
                </td>
              </tr>
            </tbody>
          </table>

          <div className={Styles.preview_screen_table_3_box}>
            <table className={Styles.preview_screen_table_3_3} style={ navigation === 3 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
              <tbody>
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center', height: '105px' }}>
                  {store.id && (
                    <img alt=''
                      style={{ width: '155px', height: '102px', objectFit: 'cover' }}
                      src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/stores%2Fresize_images%2F${store.id}_500x500?alt=media&token=?${time}`} 
                      onError={e => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = storeImageLocal;
                      }}/>
                  )}
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} style={{ textAlign: 'center', width: '50%', height: '10px' }}>施 術 頻 度</td>
                  <td colSpan={3} style={{ textAlign: 'center', width: '41%'}}>8 タ イ プ</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', width: '20%', height: '10px' }}>カット</td>
                  <td style={{ textAlign: 'center', width: '32%', }}>
                    {['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'][store.pentagonTreatment1]}
                  </td>
                  <td colSpan={3} style={{ textAlign: 'center', }}>
                  {
                    store.region && store.strengths && store.treatment ? "有名サロン" :
                    store.region && store.strengths && !store.treatment ? "トレンドサロン" :
                    store.region && !store.strengths && store.treatment ? "おしゃれサロン" :
                    store.region && !store.strengths && !store.treatment ? "ビューティーサロン" :
                    !store.region && store.strengths && store.treatment ? "オールラウンドサロン" :
                    !store.region && store.strengths && !store.treatment ? "愛されサロン" :
                    !store.region && !store.strengths && store.treatment ? "密着サロン" :
                    !store.region && !store.strengths && !store.treatment ? "こだわりサロン" : ""
                  }
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', height: '10px' }}>カラー</td>
                  <td style={{ textAlign: 'center', }}>
                    {['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'][store.pentagonTreatment2]}
                  </td>
                  <td rowSpan={2} style={{ textAlign: 'center', width: '13.7%'}}>{store.region ? '都会型' : '地域型'}</td>
                  <td rowSpan={2} style={{ textAlign: 'center', width: '13.7%'}}>{store.strengths ? '集客力' : '技術力'}</td>
                  <td rowSpan={2} style={{ textAlign: 'center', width: '13.7%'}}>{store.treatment ? 'オールマイティー' : '専門的'}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', height: '10px'}}>パーマ</td>
                  <td style={{ textAlign: 'center', }}>
                    {['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'][store.pentagonTreatment3]}
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', height: '10px'}}>縮毛矯正</td>
                  <td style={{ textAlign: 'center', }}>
                    {['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'][store.pentagonTreatment4]}
                  </td>
                  <td colSpan={3} style={{ textAlign: 'center', }}>求 人 情 報</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', height: '10px'}}>ヘアメイク</td>
                  <td style={{ textAlign: 'center', }}>
                    {['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'][store.pentagonTreatment5]}
                  </td>
                  <td colSpan={3} rowSpan={2} style={{ textAlign: 'center', }}></td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', height: '10px'}}>その他</td>
                  <td style={{ textAlign: 'center', }}>
                    {['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'][store.pentagonTreatment6]}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className={Styles.preview_screen_table_4}>
          <table className={Styles.preview_screen_table_4_1} style={ navigation === 4 || navigation === 5 || navigation === 6 || navigation === 7 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
            <tbody>
              <tr>
                <td rowSpan={12} style={{textAlign: 'center', verticalAlign: 'middle', width: '4%', }}>
                  雇　用　条　件
                </td>
                <td style={{textAlign: 'center', width: '16%', height: '10px', }}>雇用形態</td>
                <td style={{ paddingLeft: '3px', width: '71%', }}>
                  {employment20.type}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>労働制度</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.workSystem === "1年単位変形労働時間制" ? 
                    `1年単位変形労働時間制（1年：${employment20.variableWork.hoursYearly}/年）` 
                  : employment20.workSystem === "1か月単位変形労働時間制" ? 
                    `1ヶ月単位変形労働時間制（28日：${employment20.variableWork.hours28Days}時間/月、29日：${employment20.variableWork.hours29Days}時間/月、30日：${employment20.variableWork.hours30Days}時間/月、31日：${employment20.variableWork.hours31Days}時間/月）` 
                  : employment20.workSystem}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>募集区分</td>
                <td style={{ paddingLeft: '3px', }}>
                  {target.target.length > 1 ? target.target.join('、') : target.target[0]}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>雇用期間</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.contractPeriod.exist ? `定め有り　期間：${employment20.contractPeriod.text}ヶ月` : "定め無し"}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>試用期間</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.employmentTrial.exist ? `定め有り　期間：${employment20.employmentTrial.text}ヶ月　条件：${employment20.employmentTrial.conditions ?? ""}` : "定め無し"}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>基本給</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.baseSalary ? `${employment20.baseSalary}円` : ''}　制度：{employment20.salaryType}　{employment20.salaryType === "日給"? `　勤務：${employment20.dailyHours}時間/日`: ""}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>定額手当①</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.regularAllowance.allowance1 !== "" ? `${employment20.regularAllowance.allowance1}　金額：${employment20.regularAllowance.price1 ? `${employment20.regularAllowance.price1}円 /月` : ""}` : ""}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>定額手当②</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.regularAllowance.allowance2 !== "" ? `${employment20.regularAllowance.allowance2}　金額：${employment20.regularAllowance.price2 ? `${employment20.regularAllowance.price2}円 /月` : ""}` : ""}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>固定残業代</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.fixedOvertime.exist ? `固定残業代を含む　 ${employment20.fixedOvertime.price}円支給 / ${employment20.fixedOvertime.time}時間分` : "支給無し"}
                  <br />
                  {employment20.fixedOvertime.exist ? "※その時間を超過した場合、超過分は全額支給します。" : ""}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>総支給額</td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.salaryType === "年俸制" ?
                  <>
                  {([Number(employment20.baseSalary), Number(employment20.regularAllowance.price1) * 12, Number(employment20.regularAllowance.price2) * 12, Number(employment20.fixedOvertime.price) * 12  ]
                    .filter((v) => !isNaN(v)).reduce((sum, v) => sum + v, 0))}円
                  </>
                  :
                  <>
                    {([Number(employment20.baseSalary), Number(employment20.regularAllowance.price1), Number(employment20.regularAllowance.price2), Number(employment20.fixedOvertime.price)]
                      .filter((v) => !isNaN(v)).reduce((sum, v) => sum + v, 0))}円
                  </>
                  }
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', }}>
                  インセンティブ
                </td>
                <td style={{ paddingLeft: '3px', }}>
                  {employment20.incentive}
                </td>
              </tr>
            </tbody>
          </table>

          <table className={Styles.preview_screen_table_4_2}>
            <tbody style={ navigation === 8 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
              <tr>
                <td rowSpan={9} style={{textAlign: 'center', verticalAlign: 'middle', width: '4%', }}>
                  福　利　厚　生
                </td>
                <td style={{ textAlign: 'center', width: '16%', height: '10px',}} >通勤手当</td>
                <td style={{paddingLeft: '3px',width: '71%', }}>
                  {benefit.commutingAllowance.exist === "実費支給（上限有り）" || benefit.commutingAllowance.exist === "一定額" ? `支給有り　金額：${benefit.commutingAllowance.text}` 
                    : benefit.commutingAllowance.exist === "実費支給（上限無し）" ? "支給有り　金額：全額支給" : benefit.commutingAllowance.exist}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>時間外労働</td>
                <td style={{ paddingLeft: '3px', }}>
                  {benefit.overtime.exist ? `有り　平均時間：${benefit.overtime.text}時間 / 月` : "時間外労働無し"}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>勤務時間</td>
                <td style={{ paddingLeft: '3px', }}>
                  {benefit.workingHours.time1Start !== "" ? "①" : "" }
                  {benefit.workingHours.time1Start} {benefit.workingHours.time1Start === "" ? "": "~"} {benefit.workingHours.time1End}
                  {benefit.workingHours.time2Start !== "" ? "　②" : "" }
                  {benefit.workingHours.time2Start} {benefit.workingHours.time2Start === "" ? "": "~"} {benefit.workingHours.time2End}
                  （休憩：{benefit.dailyBreak}分）
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>定休日</td>
                <td style={{ paddingLeft: '3px', }}>
                  {[...new Set(benefit.regularHolidays)].join('、')}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>休日制度</td>
                <td style={{ paddingLeft: '3px', }}>
                  {benefit.holidayPolicy.exist === "その他" ? benefit.holidayPolicy.text : benefit.holidayPolicy.exist}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '20px', }}>休暇</td>
                <td style={{ paddingLeft: '3px', }}>
                  {[...new Set(benefit.daysOff)].join('、')}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>有給休暇数</td>
                <td style={{ paddingLeft: '3px', }}>
                  {benefit.paidLeave}日　年間休日：{benefit.annualHolidays}日
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>加入保険</td>
                <td style={{ paddingLeft: '3px', }}>
                  {[...new Set(benefit.insurance)].join('、')}
                </td>
              </tr>
              <tr>
                <td style={{textAlign: 'center', height: '20px', }}>
                  その他<br />福利厚生
                </td>
                <td style={{ paddingLeft: '3px', paddingRight: '3px', }}>
                  {benefit.otherText}
                </td>
              </tr>
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  受動喫煙対策
                </td>
                <td style={{ paddingLeft: '3px', }}>
                  {benefit.tabaco}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={Styles.preview_screen_table_5}>
          <table className={Styles.preview_screen_table_5_1}  style={ navigation === 9 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
            <tbody>
              <tr>
                <td rowSpan={7} style={{textAlign: 'center', verticalAlign: 'middle', width: '4%', }}>
                  応　募　情　報
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  理容
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  美容
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  メイク
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  アイ
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  ネイル
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px', fontSize: "4px"}}>
                  ブライダル
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  エステ
                </td>
              </tr>
              <tr>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsBarber === "" ? "0" : applicationInfo.recruitsBarber} 人
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsBeauty === "" ? "0" : applicationInfo.recruitsBeauty} 人
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsMake === "" ? "0" : applicationInfo.recruitsMake} 人
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsEye === "" ? "0" : applicationInfo.recruitsEye} 人
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsNeil === "" ? "0" : applicationInfo.recruitsNeil} 人
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsBridal === "" ? "0" : applicationInfo.recruitsBridal} 人
                </td>
                <td style={{textAlign: 'center', width: '13.4%', height: '10px',}}>
                  {applicationInfo.recruitsAesthetic === "" ? "0" : applicationInfo.recruitsAesthetic} 人
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>応募書類</td>
                <td colSpan={6} style={{ paddingLeft: '3px' }}>
                  {[...new Set(applicationInfo.applicationDocuments)].join('、')}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>応募方法</td>
                <td colSpan={6} style={{ paddingLeft: '3px', }}>
                  {applicationInfo.submissionMethod}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>店舗見学</td>
                <td colSpan={6} style={{ paddingLeft: '3px', }}>
                  {applicationInfo.storeTour}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: '10px', }}>応募期限</td>
                <td colSpan={6} style={{ paddingLeft: '3px', }}>
                  {formatDateToJapanese(applicationInfo.selectionDate)}
                </td>
              </tr>
            </tbody>
          </table>

          <table className={Styles.preview_screen_table_5_2}  style={ navigation === 9 ? {backgroundColor: "var(--mw-brand-pale)"} : {}}>
            <tbody>
              <tr>
                <td rowSpan={4} style={{ textAlign: 'center', verticalAlign: 'middle', width: '4%', }}>
                  採　用　試　験
                </td>
                <td style={{textAlign: 'center', width: '16%', height: "10px" }}>1次選考</td>
                <td
                  style={{paddingLeft: '3px',width: '71%', }}>
                  {applicationInfo.selectionRound1}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: "10px" }}>2次選考</td>
                <td style={{ paddingLeft: '3px', }}>
                  {applicationInfo.selectionRound2}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', height: "10px" }}>3次選考</td>
                <td style={{ paddingLeft: '3px', }}>
                  {applicationInfo.selectionRound3}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'center', }}>その他</td>
                <td style={{paddingLeft: '3px',paddingRight: '3px', }}>
                  {applicationInfo.selectionOtherDetails}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </>
  );
}

export default SchoolPreview;
